<button
  *ngIf="!isOpen"
  type="button"
  class="ai-fab"
  [class.ai-fab-nudging]="showEvaNudge"
  [class.ai-fab-bubble-visible]="showEvaNudgeBubble"
  [class.ai-fab-dragging]="isFabDragging"
  aria-label="Open Octy assistant"
  [style.left.px]="fabPosition?.x"
  [style.top.px]="fabPosition?.y"
  [style.bottom]="fabPosition ? 'auto' : ''"
  [style.right]="fabPosition ? 'auto' : ''"
  (pointerdown)="startFabDrag($event)"
  (click)="onFabClick()"
>
  <span class="ai-fab-glow"></span>
  <span class="ai-fab-star ai-fab-star-1" aria-hidden="true"></span>
  <span class="ai-fab-star ai-fab-star-2" aria-hidden="true"></span>
  <span class="ai-fab-star ai-fab-star-3" aria-hidden="true"></span>
  <span class="ai-fab-star ai-fab-star-4" aria-hidden="true"></span>
  <img
    src="/assets/media/octy-images/chatboat-img.png"
    alt="Octy"
    class="ai-fab-avatar"
    draggable="false"
  />
  <span class="ai-fab-bubble">{{ evaNudgeMessage }}</span>
</button>

<button
  type="button"
  class="ai-mobile-backdrop"
  [class.ai-mobile-backdrop-open]="isOpen"
  aria-label="Close AI assistant"
  (click)="collapse()"
></button>

<aside
  class="ai-sidebar"
  [class.ai-sidebar-open]="isOpen"
  [class.ai-sidebar-expanded]="isExpanded"
  aria-label="Octy assistant"
  style="z-index: 999"
>
  <app-ai-chat-header
    [isExpanded]="isExpanded"
    [hasConversation]="messages.length > 0"
    [activeAgentName]="activeAgent.name"
    [activeAgentColor]="activeAgent.color"
    (collapseRequested)="collapse()"
    (expandRequested)="expand()"
    (newPromptRequested)="startNewPrompt()"
    (historyRequested)="openHistory()"
    (settingsRequested)="openSettings()"
  ></app-ai-chat-header>

  <div
    style="display: none"
    *ngIf="isExpanded && messages.length > 0"
    class="ai-expanded-corner-logo"
    [class.ai-expanded-corner-logo-moved]="evaLogoPosition"
    [style.left.px]="evaLogoPosition?.left"
    [style.top.px]="evaLogoPosition?.top"
    aria-hidden="true"
    (pointerdown)="startEvaLogoDrag($event)"
  >
    <span class="ai-expanded-corner-star ai-expanded-corner-star-one"></span>
    <span class="ai-expanded-corner-star ai-expanded-corner-star-two"></span>
    <img src="/assets/media/eva/eva-logo.png" alt="" />
  </div>

  <main class="ai-sidebar-body" #sidebarBody>
    <app-ai-welcome-state
      *ngIf="messages.length === 0; else conversation"
      [isExpanded]="isExpanded"
      (suggestionSelected)="submitQuery($event)"
    ></app-ai-welcome-state>

    <ng-template #conversation>
      <!-- Panel mode: single column -->
      <ng-container *ngIf="!isExpanded">
        <app-ai-message-list
          [messages]="messages"
          (auditRequested)="openAudit($event)"
          (followUpSelected)="submitQuery($event)"
        ></app-ai-message-list>
      </ng-container>

      <!-- Expanded mode: two-column layout -->
      <ng-container *ngIf="isExpanded">
        <div class="ai-conv-layout">
          <!-- Left: messages + input -->
          <div class="ai-conv-main">
            <div class="ai-conv-messages">
              <app-ai-message-list
                [messages]="messages"
                (auditRequested)="openAudit($event)"
                (followUpSelected)="submitQuery($event)"
              ></app-ai-message-list>
            </div>
            <div class="ai-conv-input-wrap">
              <app-ai-message-input
                [selectedAgent]="activeAgent"
                (querySubmit)="submitQuery($event)"
                (agentChanged)="onAgentChanged($event)"
              ></app-ai-message-input>
            </div>
          </div>

          <!-- Right: agent + history -->
          <aside class="ai-conv-right">
            <!-- Active agent 
            <div class="ai-conv-panel">
              <div class="ai-conv-panel-label">Active agent</div>
              <div class="ai-conv-agent-row">
                <div class="ai-conv-agent-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2l7 4v5c0 5-3.5 9.7-7 11C8.5 20.7 5 16 5 11V6l7-4z"/>
                  </svg>
                </div>
                <div class="ai-conv-agent-info">
                  <div class="ai-conv-agent-name">Security Assistant</div>
                  <div class="ai-conv-agent-status"><span class="ai-conv-status-dot"></span> Active</div>
                </div>
                <button type="button" class="ai-conv-change-btn">Change</button>
              </div>
            </div>
-->
            <!-- Chat history -->
            <div class="ai-conv-history-section">
              <div class="ai-conv-history-header">
                <span class="ai-conv-history-label">Chat history</span>
                <div class="ai-conv-history-actions">
                  <button
                    type="button"
                    class="ai-conv-new-btn"
                    (click)="startNewPrompt()"
                    title="New conversation"
                  >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  </button>
                  <button type="button" class="ai-conv-view-all">
                    View all
                  </button>
                </div>
              </div>
              <ul class="ai-conv-history-list">
                <li
                  *ngFor="let chat of recentChats"
                  class="ai-conv-history-item"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="ai-conv-history-icon"
                  >
                    <path
                      d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"
                    />
                  </svg>
                  <span class="ai-conv-history-title">{{ chat.title }}</span>
                  <span class="ai-conv-history-time">{{ chat.time }}</span>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </ng-container>
    </ng-template>
  </main>

  <!-- Panel mode only — in expanded mode the input is inside ai-conv-main -->
  <footer class="ai-sidebar-footer" *ngIf="messages.length > 0 && !isExpanded">
    <app-ai-message-input
      [selectedAgent]="activeAgent"
      (querySubmit)="submitQuery($event)"
      (agentChanged)="onAgentChanged($event)"
    ></app-ai-message-input>
  </footer>
</aside>

<app-audit-prompt-dialog
  [audit]="selectedAudit"
  (closeRequested)="closeAudit()"
></app-audit-prompt-dialog>
